import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/BreadCrumb/breadCrumb';
import Strings from '../../../constants/stringConstant';
import Path from '../../../constants/path';
import sharedStyles from '../Masters.module.css';
import { Box, Grid, IconButton } from '@mui/material';
import SearchBox from '../../../components/SearchBox/searchBox';
import ButtonComp from '../../../components/Button/buttonComp';
import { ReactComponent as AddIcon } from '../../../assets/images/addIconWhite.svg';
import PaginationComp from '../../../components/Pagination/paginationComp';
import ModalwithButton from '../../../components/Modal/modalwithButton';
import AddEditEStampMaster from './AddEditEStampMaster';
import { toast } from 'react-toastify';
import makeApiCall from '../../../api/makeApiCall';
import SuccessModal from '../../../components/Modal/successModal';
import { ReactComponent as EditSharpIcon } from '../../../assets/images/editIcon.svg';
import TableComp from '../../LoanApplicationsPage/LoanApplicationsDashboard/OtherLoanApplicationStages/componenets/StaticPages/EligibilityCheck/CamTab/TableComp';
import { useSelector } from 'react-redux';
import { addUpdateEStampMaster, fetchEStampMaster } from '../../../api/request/masterFetchApi/masterFetchApi';

function EStampMaster() {
    const paths = [
        {
            name: Strings.masters.masters,
            link: Path.e_stamp_master,
        },
        { name: Strings.masters.estamp_master, link: '' },
    ];
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [addEditEStampModal, setAddEditEStampModal] = useState(false);
    const [type, setType] = useState('add');
    const [selectedRowObject, setSelectedRowObject] = useState({});
    const [totalPages, setTotalPages] = useState(0);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [noRecordsFound, setNoRecordsFound] = useState(false);
    const [failedModal, setFailedModal] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const { roleBased } = useSelector(state => state.rbacValue);
    const isEditEStamp = roleBased?.masters?.sections?.['e-stamp_master'] !== 'edit';
    const rowPerTable = 10;

    function toggleAddEditEStampModal() {
        setAddEditEStampModal(!addEditEStampModal);
    }

    useEffect(() => {
        fetchEStampMasterApi();
    }, [searchQuery, currentPage]);

    useEffect(() => {
        if (successModal) {
            setTimeout(() => {
                handleSuccessModal();
            }, 2000);
        }
    }, [successModal]);

    useEffect(() => {
        if (failedModal) {
            setTimeout(() => {
                handleFailedModal();
            }, 2000);
        }
    }, [failedModal]);

    const handleApiError = response => {
        toast.error(response?.data?.error?.errorMessage, { position: 'top-right' });
    };

    const fetchEStampMasterApi = async () => {
        setLoading(true);
        try {
            const requestPayload = {
                pageNumber: currentPage - 1,
                pageSize: rowPerTable,
                searchTerm: searchQuery,
            };
            const response = await makeApiCall(fetchEStampMaster(requestPayload));
            if (response?.data?.status === Strings?.success) {
                const data = response?.data?.data?.content ?? [];
                setRows(data);
                setTotalPages(
                    Math.ceil(response?.data?.data?.totalElements / rowPerTable),
                );
                if (data?.length === 0) {
                    setNoRecordsFound(true);
                } else {
                    setNoRecordsFound(false);
                }
            } else {
                handleApiError(response);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const addUpdateEStampMasterApi = async (data, states) => {
        setLoading(true);
        try {
            const requestPayload = {
                id: data?.id || null,
                stateId: states?.find(state => state.stateName === data?.stateName)?.stateId ?? data?.stateId,
                stampSeriesNumber: data?.stampSeriesNumber ?? '',
                status: data?.status,
            };
            const response = await makeApiCall(addUpdateEStampMaster(requestPayload));
            if (response?.data?.status === Strings?.success) {
                setSuccessModal(true);
                fetchEStampMasterApi();
            } else {
                handleApiError(response);
                setFailedModal(true);
                setSuccessModal(false);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const loanColumns = [
        { label: 'State Name', field: 'stateName' },
        { label: 'Stamp Series Number', field: 'stampSeriesNumber' },
    ];

    const handleSearch = query => {
        setSearchQuery(query);
        setCurrentPage(1);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleSuccessModal = () => {
        setSuccessModal(false);
    };

    const handleFailedModal = () => {
        setFailedModal(false);
    };

    const handleStatusChange = selectedRow => {
        setSelectedRowObject(selectedRow);
        setModalVisible(true);
    };

    const handleStatusCancel = () => {
        setModalVisible(false);
        setSelectedRowObject({});
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const updatedStatus = !selectedRowObject.status;
            const requestPayload = {
                ...selectedRowObject,
                status: updatedStatus,
            };
            const response = await makeApiCall(addUpdateEStampMaster(requestPayload));
            if (response?.data?.status === Strings.success) {
                fetchEStampMasterApi();
                setModalVisible(false);
                setSelectedRowObject({});
            } else {
                handleApiError(response);
            }
        } catch (error) {
            console.error('API Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box className={sharedStyles.main_container}>
            <Breadcrumb paths={paths} />
            <Box className={sharedStyles.secondary_container}>
                <Grid
                    container
                    sx={{
                        gap: '12px',
                        justifyContent: 'space-between',
                    }}>
                    <Grid item>
                        <SearchBox searchQuery={searchQuery} onSearch={handleSearch} />
                    </Grid>
                    <Grid item>
                        <Grid
                            container
                            sx={{
                                gap: '12px',
                            }}>
                            <ButtonComp
                                type="submit"
                                className="text-bold-16px"
                                endIcon={<AddIcon />}
                                value={Strings.masters.add_new}
                                gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                                height="40px"
                                padding="14px 24px"
                                textcolor="#fff"
                                borderRadius="8px"
                                onClick={() => {
                                    setType('add');
                                    toggleAddEditEStampModal();
                                }}
                                disabled={isEditEStamp}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <TableComp
                    loader={loading}
                    columns={loanColumns}
                    rows={rows}
                    editDisabled={isEditEStamp}
                    handleActionClick={row => {
                        setType('edit');
                        toggleAddEditEStampModal();
                        setSelectedRowObject(row);
                        fetchEStampMasterApi();
                    }}
                    showTotal={false}
                    firstColumnBgColor={'white'}
                    statusColumn={true}
                    statusChange={handleStatusChange}
                    noRecordsFound={noRecordsFound}
                    actionIcon={
                        <IconButton aria-label="close" disabled={isEditEStamp}>
                            <EditSharpIcon />
                        </IconButton>
                    }
                />
                {totalPages > 0 && !noRecordsFound && (
                    <PaginationComp
                        totalPages={totalPages}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                    />
                )}
            </Box>
            {addEditEStampModal && (
                <ModalwithButton
                    open={addEditEStampModal}
                    message={type === 'add' ? 'Add E-Stamp Details' : 'Edit E-Stamp Details'}
                    subMessage={
                        'Fill in the below details to add them to the master table'
                    }
                    leftRenderWithoutPadding
                    bolderHeadings
                    subMessageColor={'#475467'}
                    onClose={toggleAddEditEStampModal}
                    minWidth={'50%'}>
                    <AddEditEStampMaster
                        closeModal={toggleAddEditEStampModal}
                        selectedRowObject={selectedRowObject}
                        type={type}
                        addUpdateEStampMasterApi={addUpdateEStampMasterApi}
                    />
                </ModalwithButton>
            )}
            <SuccessModal
                open={successModal}
                onClose={handleSuccessModal}
                message={
                    type === 'add'
                        ? Strings.masters.added_record
                        : Strings.masters.updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.added_record_des
                        : Strings.masters.updated_record_des
                }
            />
            <SuccessModal
                open={failedModal}
                onClose={handleFailedModal}
                message={
                    type === 'add'
                        ? Strings.masters.failed_added_record
                        : Strings.masters.failed_updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.failed_added_record_des
                        : Strings.masters.failed_updated_record_des
                }
                reject
            />
            <ModalwithButton
                open={isModalVisible}
                message={Strings.masters.status_change}
                subMessage={Strings.masters.status_change_msg}
                value={'Yes'}
                onClickButton={handleConfirm}
                onClose={handleStatusCancel}
                cancelBtn
            />
        </Box>
    );
}

export default EStampMaster;
